import React from 'react';

const LandscapeWarning = () => {
  return (
    <div className="landscape-overlay">
      <div className="landscape-message flex justify-center flex-col items-center">
        <img  style={{height:"50px"}} src="https://t4.ftcdn.net/jpg/00/53/80/55/360_F_53805518_LMH6ZooHbgfWNxYipXFCdWrKWif3o5Gz.jpg" alt="" />
       <div className='mt-4'>
       This application does not work in landscape mode.
       <br/>
       <span>
       Please rotate your device to portrait mode.
       </span>
       </div>
      </div>
    </div>
  );
};

export default LandscapeWarning;
